import { Button, ListItem, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { UNDEFINED_DISPLAY_KEY } from '../../../../constants';
import { GlobalFilterTypeHandle } from '../../../../context/types';
import { FilterTypes } from '../filterbar/types';
import { HierarchyItem } from '../types';
import { itemToFilters } from '../utils';

interface SelectAllClearAllButtonGroupProps<T extends FilterTypes> {
  level: number;
  subItems: HierarchyItem[];
  filterHandle: GlobalFilterTypeHandle<T>;
}

export const SelectAllClearAllButtonGroup = <T extends FilterTypes>(
  props: SelectAllClearAllButtonGroupProps<T>
) => {
  const { t } = useTranslation();
  const { subItems, filterHandle, level } = props;
  const [, filterDispatch] = filterHandle;

  return (
    <ListItem
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        paddingTop: '0.7em',
        paddingBottom: '0.7em',
        marginLeft: '-11.5px',
      }}
    >
      <Button
        size="small"
        variant="outlined"
        onClick={(e) => {
          e.stopPropagation();
          filterDispatch({
            type: 'add-multiple',
            items: subItems.flatMap((i) =>
              itemToFilters(
                i,
                level,
                i.labelFn(t, t(UNDEFINED_DISPLAY_KEY), true)
              )
            ),
          });
        }}
        color="secondary"
        data-cy="panalyt-filter-select-all"
      >
        <Typography variant="caption" color="textSecondary">
          {t('common:filterTray.selectAll')}
        </Typography>
      </Button>
      <Button
        variant="outlined"
        onClick={(e) => {
          e.stopPropagation();
          filterDispatch({
            type: 'remove-multiple',
            items: subItems.flatMap((i) =>
              itemToFilters(
                i,
                level,
                i.labelFn(t, t(UNDEFINED_DISPLAY_KEY), true)
              )
            ),
          });
        }}
        size="small"
        color="secondary"
      >
        <Typography variant="caption" color="textSecondary">
          {t('common:filterTray.clearAll')}
        </Typography>
      </Button>
    </ListItem>
  );
};
